/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevokeTokenReq
 */
export interface RevokeTokenReq {
    /**
     * A JWT token. Can be either a User token (`UserTokenText`) or a Token Container (`TokenContainerText`)
     * @type {string}
     * @memberof RevokeTokenReq
     */
    token: string;
}

/**
 * Check if a given object implements the RevokeTokenReq interface.
 */
export function instanceOfRevokeTokenReq(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;

    return isInstance;
}

export function RevokeTokenReqFromJSON(json: any): RevokeTokenReq {
    return RevokeTokenReqFromJSONTyped(json, false);
}

export function RevokeTokenReqFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevokeTokenReq {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function RevokeTokenReqToJSON(value?: RevokeTokenReq | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}

